<div class="day-header flex flex-col items-center justify-center">
  <span class="weekday">{{ day().date | date: 'EEE' }}</span>
  <span
    class="day-number flex items-center justify-center"
    [class.today]="day().isToday"
  >
    {{ day().date | date: 'd' }}
  </span>
</div>
<div class="day-body" [style.height.px]="height">
  @for (top of hourLines; track $index) {
    <div class="hour-line" [style.top.px]="top"></div>
  }
  @if (content(); as content) {
    <ng-container
      [ngTemplateOutlet]="content"
      [ngTemplateOutletContext]="{ $implicit: day(), nowMinutes: nowMinutes() }"
    />
  }
  <div class="past" [style.height.px]="pastHeight()"></div>
  @if (day().isToday) {
    <div
      class="now-line"
      data-test-id="schedule-calendar-now-line"
      [style.top.px]="nowTop()"
    ></div>
  }
</div>
